import { coreInstance } from "../index";
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getProvinceOnUse({}) {
      return coreInstance
        .get("/api/v1/merChant/getProvince")
        .then(res => {
          return res.data;
        })
        .catch(error => {
          return false;
        });
    },
    getDistrictOnuse({}, provinceID) {
      return coreInstance
        .get("/api/v1/merChant/getDistrict/" + provinceID)
        .then(res => {
          return res.data.data;
        })
        .catch(error => {
          return [];
        });
    },
    getSubDistrictOnuse({}, { provinceID, districtID }) {
      return coreInstance
        .get("/api/v1/merChant/getSubDistrict/" + provinceID + "/" + districtID)
        .then(res => {
          return res.data.data;
        })
        .catch(error => {
          return [];
        });
    },
    getZipcodeOnuse({}, districtID) {
      return coreInstance
        .get("/api/v1/merChant/getZipcode/" + districtID)
        .then(res => {
          return res.data.data;
        })
        .catch(error => {
          return [];
        });
    }
  },
  modules: {}
};
